export default new class Like {
	constructor() {
		this.selectors = {
			likeButton: '.js-like',
			likeCounter: 'div.flex div:last-child'
		};
	}

	init() {
		this.initLike();
	}

	async updateLikeCountView(likeButton, action) {
		const counterElement = likeButton.closest('div.flex').querySelector(this.selectors.likeCounter);
		const currentCount = parseInt(counterElement.textContent.trim()) || 0;
		const newCount = action === 'add' 
            ? currentCount + 1 
            : (currentCount - 1) <= 0 
                ? ''
                : currentCount - 1
            ;
        ;
		
        counterElement.textContent = newCount;
		likeButton.classList.toggle('active');
		
		return newCount;
	}

	async sendLikeRequest(articleId, action) {
		const data = new FormData();
		data.append('event', 'article_like');
		data.append('article_id', articleId);
		data.append('action', action);

		try {
			await fetch(window.location.href, {
				method: 'POST',
				body: data,
				redirect: 'follow'
			});
		} catch (error) {
			console.error('Erreur lors de la mise à jour du like:', error);
			throw error;
		}
	}

	initLike() {
		document.querySelectorAll(this.selectors.likeButton).forEach(likeButton => {
			likeButton.addEventListener('click', async () => {
				try {
					const action = likeButton.classList.contains('active') ? 'remove' : 'add';
					
					// Mise à jour optimiste de l'UI
					this.updateLikeCountView(likeButton, action);
					
					// Envoi de la requête au serveur
					await this.sendLikeRequest(likeButton.dataset.id, action);
				} catch (error) {
					// En cas d'erreur, on revient à l'état précédent
					this.updateLikeCountView(likeButton, action === 'add' ? 'remove' : 'add');
				}
			});
		});
	}
}